import { FC } from "react";
import useAccountMenu from "@/app/lib/features/accountMenu/accountMenu.hook";
import FallbackImage from "@/app/components/elements/FallbackImage";
import RosetteInfoPopover from "./RosetteInfoPopover";

export const UserPointsBadge: FC = () => {
  const { headerMenuData } = useAccountMenu();
  const rosetteInfo = headerMenuData?.rosette_info;

  if (!rosetteInfo) return null;

  return (
    <div
      className="relative overflow-hidden mx-3 mb-3 rounded-lg px-3 py-2.5 space-y-2.5"
      style={{ backgroundColor: rosetteInfo.background_color }}
    >
      {/* Overlay daireler */}
      <div className="absolute -top-4 -right-4 w-16 h-16 rounded-full bg-white/10 pointer-events-none" />
      <div className="absolute -bottom-5 -right-1 w-12 h-12 rounded-full bg-white/5 pointer-events-none" />

      {/* Rozet satırı */}
      <div className="relative flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          {rosetteInfo.icon && (
            <div className="relative w-5 h-5 shrink-0">
              <FallbackImage src={rosetteInfo.icon} alt={rosetteInfo.name} fill sizes="20px" className="object-contain" />
            </div>
          )}
          <div>
            <p className="text-[11px] text-white/60 leading-none">{rosetteInfo.title}</p>
            <p className="text-sm font-bold text-white leading-tight">{rosetteInfo.name}</p>
          </div>
        </div>
        <div className="flex items-center gap-1.5 shrink-0">
          <div className="text-right">
            <p className="text-[11px] text-white/60 leading-none">{rosetteInfo.expense_title}</p>
            <p className="text-sm font-bold text-white leading-tight">{rosetteInfo.expense_amount}</p>
          </div>
          <RosetteInfoPopover rosetteInfo={rosetteInfo} side="left" />
        </div>
      </div>

      {/* Progress bar */}
      <div className="relative">
        <div className="flex justify-between text-[11px] text-white/60 mb-1">
          <span>{rosetteInfo.start_amount}</span>
          <span>{rosetteInfo.end_amount}</span>
        </div>
        <div className="h-1.5 bg-white/20 rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-700"
            style={{ width: `${rosetteInfo.progress}%`, backgroundColor: rosetteInfo.progress_color }}
          />
        </div>
        <p className="text-[11px] text-white/60 mt-1">{rosetteInfo.detail}</p>
      </div>
    </div>
  );
};